import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { EditService } from '../../../../services/index';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import * as moment from 'moment';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as fromCommonStore from '../../../../store';
import * as fromRootStore from '../../../../reducers';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { FollowUpService, CommonService } from '../../../../services/index';
import swal from 'sweetalert2';
@Component({
    selector: 'edit-tab',
    templateUrl: './addeditsoa.component.html',
})
export class SOAAddEditComponent implements OnInit {
    isLoading: boolean;
    hvList: {}[];
    hvTypeList: {}[];
    //@Input() editHvData = [];
    editSoa: any = [];

    hvcomplaintCtrl: FormControl;
    soacomplaintCtrl: FormControl;
    hvpotCtrl: FormControl;
    soapotCtrl: FormControl;
    branchCtrl: FormControl;
    followUpDateCtrl: FormControl;
    unsoldCtrl: FormControl;
    soldCtrl: FormControl;
    statusCtrl: FormControl;
    haUserCtrl: FormControl;
    toWhomControl: FormControl;
    billDetailCtrl: FormControl;
    freeItemCtrl: FormControl;
    serviceCtrl: FormControl;
    usingMethodCtrl: FormControl;
    testingtypeCtrl: FormControl;
    ratingCtrl: FormControl;
    drConsCtrl: FormControl;
    folTypeCtrl: FormControl;
    hvStatusCtrl: FormControl;
    soaStatusCtrl: FormControl;
    halistCtrl: FormControl;
    hvCtrl: FormControl;
    soaCtrl: FormControl;
    hvpotCusOptList: any[];
    soapotCusOptList: any[];
    branchList: any[] = [];
    _followUpDet: any[] = [];
    userList: any[];
    toWhomList: any[];
    billDetailList: any[];
    freeItemList: any[];
    serviceList: any[];
    usingMethodList: any[];
    ratingList: any[];
    drList: any[];
    col_statusList: any;
    page = {
        limit: 10,
        count: 0,
        offset: 0,
        orderBy: 'date',
        orderDir: 'desc'
    };
    isLoadMask: Promise<any>;
    haList: any[] = [];
    hapromoList: any[] = [];
    loadingIndicator: boolean = true;
    //followUpHistoryList = [];
    columns = [];
    emplist1Ctrl: FormControl;
    complCtrl: FormControl;
    emplist2Ctrl: FormControl;
    filteredHa: Observable<any[]>;
    filteredEmp1: Observable<any[]>;
    filteredEmp2: Observable<any[]>;
    filteredTypes: Observable<any[]>;
    filteredhvComplaint: Observable<any[]>;
    filteredsoaComplaint: Observable<any[]>;
    unsoldFeedBackList: any[];
    empList: any[] = [];
    soldFeedBackList: any[];
    followTypeList: any[];
    soaTypeList: any[];
    testingList: any[] = [];
    soaList: any[];
    HVstatusList: any[];
    minDate: any;
    @ViewChild('emp1listAutoComp') emp1listAutoComp;
    @ViewChild('emp2listAutoComp') emp2listAutoComp;
    @Output() soaDataLoadEvent = new EventEmitter();
    @Input() set editSoaData(val: any[]) {
        this.editSoa = val;
        this.editSoa['apdate'] = new Date(val['soa_date']);
        this.loadFollowUpDetails();
        // this.pageCallback({ offset: 0 });
        //this.onClickPick();//INITIAL PICK OPEN
    }
    //f//ilteredEmp1: Observable<any[]>;
    //filteredEmp2: Observable<any[]>;


    constructor(public editservice: EditService, public store: Store<fromRootStore.State>, public bsModalRef: BsModalRef
        , public commonService: CommonService) {
        this.loadFollowUpDetails();
        function hasValidUnSold(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Willing" && ledgerID != "Not-Willing"
                && ledgerID != "No-Answer") {
                retVal = { inValidUnsold: true };
            }

            return retVal;
        }
        this.unsoldCtrl = new FormControl('', [
            Validators.required,
            hasValidUnSold.bind(this)
        ]);
        // this.unsoldCtrl = new FormControl();
        this.unsoldFeedBackList = ['Willing', 'Not-Willing', 'No-Answer'];
        this.col_statusList = ['One Month Completed', 'One Year Completed', 'Two Year Completed']
        function hasValidSold(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Satisfied" && ledgerID != "Not-Satisfied"
                && ledgerID != "No-Answer") {
                retVal = { inValidSold: true };
            }

            return retVal;
        }

        //this.soldCtrl = new FormControl();
        this.soldFeedBackList = ['Satisfied', 'Not-Satisfied', 'No-Answer'];
        this.followTypeList = ['Call Drop', 'Follow Up', 'Not Ok', 'Not Willing Now','Done'];
        //this.hvTypeList = ['HV', 'HV-Recheckup', 'HV-Fitting','HV-ReTrial','HV-ReTrail-Fitting'];
        //  this.soaTypeList = ['SOA', 'SOA-Recheckup', 'SOA-Fitting','SOA-ReTrial','SOA-ReTrail-Fitting'];
        //  this.hvList = ['Sold', 'Unsold','Cancel','Advance','EMI','HV-EMI', 'HV-RecheckUp',
        //   'HV-Retrail-Unsold','HV-Retrail-Sold', 'HV-Retrail-Advance','HV-Retrail-EMI', 
        //   'HV-Delivery', 'HV-Retrail-Delivery'];
        // this.soaList = ['Sold', 'Unsold','Cancel','Advance','EMI','SOA-EMI', 'SOA-RecheckUp',
        //  'SOA-Retrail-Unsold','SOA-Retrail-Sold', 'SOA-Retrail-Advance','SOA-Retrail-EMI', 
        //  'SOA-Delivery', 'SOA-Retrail-Delivery'];

        this.folTypeCtrl = new FormControl();
        this.hvStatusCtrl = new FormControl();
        this.soaStatusCtrl = new FormControl();
        this.hvCtrl = new FormControl();
        this.soaCtrl = new FormControl();
        this.followUpDateCtrl = new FormControl();

        function hasValidUser(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidHAuser: true };
            }

            return retVal;
        }
        this.haUserCtrl = new FormControl('', [
            Validators.required,
            hasValidUser.bind(this)
        ]);
        this.userList = ['Yes', 'No'];

        function hasValidToWhom(input: FormControl) {
            let toWhom = input.value, retVal = null;
            if (toWhom != "SELF" && toWhom != "OTHERS") {
                retVal = { inValidToWhom: true };
            }

            return retVal;
        }
        this.toWhomControl = new FormControl('', [
            Validators.required,
            hasValidToWhom.bind(this)
        ]);
        this.toWhomList = ['SELF', 'OTHERS'];
        //FOR AUTO COMPLETE VALIDATION --- 
        function hasValidDr(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidDr: true };
            }

            return retVal;
        }
        this.drConsCtrl = new FormControl('', [
            Validators.required,
            hasValidDr.bind(this)
        ]);
        this.drList = ['Yes', 'No'];

        // bill Detail
        function hasValidBill(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidBillDetail: true };
            }

            return retVal;
        }
        this.billDetailCtrl = new FormControl('', [
            Validators.required,
            hasValidBill.bind(this)
        ]);
        this.billDetailList = ['Yes', 'No'];



        ///free ITEM
        function hasValidFree(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidFreeItem: true };
            }

            return retVal;
        }
        this.freeItemCtrl = new FormControl('', [
            Validators.required,
            hasValidFree.bind(this)
        ]);
        this.freeItemList = ['Yes', 'No'];

        //this.getBranchList();
        function hasValidBranch(input: FormControl) {
            let branchID = input.value;
            let femp = _.find(this.branchList, { 'branch_id': branchID });
            if (femp)
                return null;
            return { inValidBranch: true };
        }
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);

        // SERVICE
        function hasValidService(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidService: true };
            }

            return retVal;
        }
        this.serviceCtrl = new FormControl('', [
            Validators.required,
            hasValidService.bind(this)
        ]);
        this.serviceList = ['Yes', 'No'];

        // Using Method
        function hasValidUsingMethod(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidUsingMethod: true };
            }

            return retVal;
        }
        this.usingMethodCtrl = new FormControl('', [
            Validators.required,
            hasValidUsingMethod.bind(this)
        ]);
        this.usingMethodList = ['Yes', 'No'];

        // Rating
        function hasValidRating(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Very Good" && ledgerID != "Good"
                && ledgerID != "Normal" && ledgerID != "Bad") {
                retVal = { inValidRating: true };
            }

            return retVal;
        }
        this.ratingCtrl = new FormControl('', [
            Validators.required,
            hasValidRating.bind(this)
        ]);
        this.ratingList = ['Very Good', 'Good', 'Normal', 'Bad'];
        // this.HVTypeCtrl = new FormControl();
        //this.filteredItems = this.skuCtrl.valueChanges
        //    .startWith(null)
        //    .map(name => name ? this.filterItems(name) : this.itemList.slice());

        //FOR AUTO COMPLETE VALIDATION --- FOLLOW UP STATUS
        function hasValidStatus(input: FormControl) {
            let statusID = input.value, retVal = null;
            if (statusID == "") {
                retVal = { inValidStatus: true };
            }
            if (statusID && typeof statusID === 'string') {
                retVal = { inValidStatus: true };
            }
            return retVal;
        }
        this.statusCtrl = new FormControl('', [
            Validators.required,
            hasValidStatus.bind(this)
        ]);
        //FOR AUTO COMPLETE VALIDATION --- TYPE
        function hasValidType(input: FormControl) {
            let type = input.value, retVal = null;
            if (type == "") {
                retVal = { inValidType: true };
            }
            let typeVal = this.followTypeList.find(function (element) {
                if (element == input.value) return true;
            })
            if (!typeVal) {
                retVal = { inValidType: true };
            }
            return retVal;
        }
        this.folTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);



        function hasEmp1(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidEMP1: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEMP1: true };
            }
            return retVal;
        }
        this.emplist1Ctrl = new FormControl('', [
            Validators.required,
            hasEmp1.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredEmp1 = this.emplist1Ctrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());


        function hasEmp2(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidEMP2: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEMP2: true };
            }
            return retVal;
        }
        this.emplist2Ctrl = new FormControl('', [
            Validators.required,
            hasEmp2.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredEmp2 = this.emplist2Ctrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;

            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        function hashvComplaint(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidhvComplaint: true };
            }
            /* if (ModelID && typeof ModelID === 'string') {
                 retVal = { inValidComplaint: true };
             }*/
            return retVal;
        }
        this.hvcomplaintCtrl = new FormControl('', [
            Validators.required,
            hashvComplaint.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();

        function hassoaComplaint(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidsoaComplaint: true };
            }
            /* if (ModelID && typeof ModelID === 'string') {
                 retVal = { inValidComplaint: true };
             }*/
            return retVal;
        }
        this.soacomplaintCtrl = new FormControl('', [
            Validators.required,
            hassoaComplaint.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        function hasValidTestType(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidTestType: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidTestType: true };
            }
            return retVal;
        }
        this.testingtypeCtrl = new FormControl('', [
            Validators.required,
            hasValidTestType.bind(this)
        ]);

        //this.testingtypeCtrl = new FormControl();
        this.filteredTypes = this.testingtypeCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterTypes(name) : this.testingList.slice());


        function hasValidPothv(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidPothv: true };
            }

            return retVal;
        }
        this.hvpotCtrl = new FormControl('', [
            Validators.required,
            hasValidPothv.bind(this)
        ]);
        this.hvpotCusOptList = ['Yes', 'No'];



    }

    ngOnInit() {
        this.editSoa['client_id'] = 12;
        this.editSoa['client_name'] = "BEER";
        this.loadFollowUpDetails();
        this.loadChallanHaList();
        this.loadClientTypeList();
    }

    loadChallanHaList() {
        let that = this,
            data = {
                name: '',
                type: 'challan'
            };
        this.commonService
            .getEmployeeName(data)
            .then(function (res: any) {
                that.haList = res['data'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.emplist1Ctrl.setValue(that.editSoa['empid1']);
                that.emplist2Ctrl.setValue(that.editSoa['empid2']);
            });
    }
    loadFollowUpDetails() {
        let that = this;
        this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            let followup = that['followUpTeam'];
            //console.log(that);
            //debugger;
            //this.followUpStatusList = _.filter(res.data, function (obj) { return obj['is_followup'] == 'Yes' && obj[followup] == 'Yes' });
            this.hvTypeList = _.filter(res.data, function (obj) { return obj['soa_status'] == 'Yes' });
            //this.soaTypeList = _.filter(res.data, function (obj) { return obj['soa_status'] == 'Yes' });
            this.hvList = _.filter(res.data, function (obj) { return obj['soa_out_status'] == 'Yes' });
            //this.soaList = _.filter(res.data, function (obj) { return obj['soa_out_status'] == 'Yes' });
        });
    }
    displayFnHV(folID: any) {
        if (this.hvTypeList != undefined) {
            if (folID && this.hvTypeList.length > 0) {
                let fitem = _.find(this.hvTypeList, { 'fol_id': folID });
                return fitem['name'];
            }
        }
        return '';
    }
    filterHa(empname: string) {
        empname = _.escapeRegExp(empname);
        return this.haList.filter(ha => (new RegExp(empname, 'gi').test(ha.empid)
            || new RegExp(empname, 'gi').test(ha.empname)));
    }
    displayHa(item_id: number) {
        if (item_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'empid': item_id });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['empname'];
        }
        return '';
    }
    loadClientTypeList() {
        let that = this;
        this.commonService
            .getTestingtypeList()
            .then(function (res: any) {
                that.testingList = res;
                that.testingtypeCtrl.setValue(that.editSoa['testing']);
            });
    }
    displayType(type_id: number) {
        if (type_id && this.testingList.length > 0) {
            let ftype = _.find(this.testingList, { 'id': type_id });
            return ftype['name'];
        }
        return '';
    }

    filterTypes(name: string) {
        name = _.escapeRegExp(name);
        return this.testingList.filter(type => (new RegExp(name, 'gi').test(type.name)));
    }
    displayFnHVOUT(folID: any) {
        if (this.hvList != undefined) {
            if (folID && this.hvList.length > 0) {
                let fitem = _.find(this.hvList, { 'fol_id': folID });
                return fitem['name'];
            }
        }
        return '';
    }

    onSaveHv() {
        let params = {
            id: this.editSoa['st_det_id'],
            client_id: this.editSoa['client_id'],
            client_name: this.editSoa['client_name'],
            date: moment(this.editSoa['apdate']).format('YYYY-MM-DD'),
            emp1: this.editSoa['empid1'],
            emp2: this.editSoa['empid2'],
            soa_type: this.editSoa['last_status'],
            expense: this.editSoa['travel_expense'],
            soa_out_status: this.editSoa['soa_out_status'],
            testing: this.editSoa['testing']

        };
        let that = this;
        this.isLoadMask = this.editservice
            .savesoaeditlist(params)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal(
                        'SUCCESS',
                        res.message,
                        'success'
                    );
                    that.bsModalRef.hide();
                    that.soaDataLoadEvent.emit();
                }
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/Edit/soaedit/addeditsoa.component.ts